export default __webpack_public_path__ + "static/media/gray-img-sm.4e60bf10.svg";